import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

import type {PsrState} from '../types/psr.types';

const INITIAL_STATE = {
  psrsWithProducts: [],
  psrsSelected: [],
  psrsGroupShow: [],
  textPsrsMessage: false,
  psrPaymentType: {
    ecommerce: false,
    physical: false
  },
  psrGroupTypes: {
    ecommerce: [],
    physical: []
  },
  psrCodePhysical: [],
  psrCodeEcommerce: []
};

export const usePsrStore = create<PsrState>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      setPsrsWithProducts: (psr) =>
        set(
          (state) => ({
            psrsWithProducts: [...state.psrsWithProducts, psr]
          }),
          false,
          'psr/setPsrsWithProducts'
        ),

      setPsrsSelected: (psrs) =>
        set({psrsSelected: psrs}, false, 'psr/setPsrsSelected'),

      setShowTextPsrMessage: (flag) =>
        set({textPsrsMessage: flag}, false, 'psr/setShowTextPsrMessage'),

      setPsrsGroupShow: (psrs) =>
        set({psrsGroupShow: psrs}, false, 'psr/setPsrsGroupShow'),

      setPsrPaymentType: (type) =>
        set({psrPaymentType: type}, false, 'psr/setPsrPaymentType'),

      setPsrGroupType: (types) =>
        set({psrGroupTypes: types}, false, 'psr/setPsrGroupType'),

      setPsrCodeEcommerce: (codes) =>
        set({psrCodeEcommerce: codes}, false, 'psr/setPsrCodeEcommerce'),

      setPsrCodePhysical: (codes) =>
        set({psrCodePhysical: codes}, false, 'psr/setPsrCodePhysical')
    }),
    {name: 'PsrStore'}
  )
);

export const selectPsrsWithProducts = (state: PsrState) =>
  state.psrsWithProducts;
export const selectPsrsSelected = (state: PsrState) => state.psrsSelected;
export const selectPsrsGroupShow = (state: PsrState) => state.psrsGroupShow;
export const selectTextPsrsMessage = (state: PsrState) => state.textPsrsMessage;
export const selectPsrPaymentType = (state: PsrState) => state.psrPaymentType;
export const selectPsrGroupTypes = (state: PsrState) => state.psrGroupTypes;
export const selectPsrCodePhysical = (state: PsrState) => state.psrCodePhysical;
export const selectPsrCodeEcommerce = (state: PsrState) =>
  state.psrCodeEcommerce;
